export function show(): void {
  if (!document.querySelector('.pp-spinner')) {
    const spinDiv = document.createElement('div');
    spinDiv.id = 'pp-spin';
    spinDiv.className = 'pp-spinner';
    Object.assign(spinDiv.style, {
      position: 'fixed', top: '50%', left: '50%',
      transform: 'translate(-50%, -50%)', zIndex: '510',
      backgroundColor: '#fff', padding: '26px', borderRadius: '4px',
    });

    const bgDiv = document.createElement('div');
    bgDiv.id = 'pp-spin-bg';
    bgDiv.className = 'pp-spinner';
    Object.assign(bgDiv.style, {
      position: 'fixed', top: '0', left: '0', zIndex: '500',
      width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)',
    });

    const wheel = document.createElement('div');
    Object.assign(wheel.style, {
      width: '32px', height: '32px', border: '4px solid #ccc',
      borderTopColor: '#000', borderRadius: '50%',
      animation: 'pp-spin 0.8s linear infinite',
    });
    spinDiv.appendChild(wheel);

    if (!document.getElementById('pp-spin-keyframes')) {
      const style = document.createElement('style');
      style.id = 'pp-spin-keyframes';
      style.textContent = '@keyframes pp-spin { to { transform: rotate(360deg); } }';
      document.head.appendChild(style);
    }

    document.body.append(bgDiv, spinDiv);
  }

  for (const el of document.querySelectorAll<HTMLElement>('.pp-spinner')) {
    el.style.display = '';
  }
}

export function hide(): void {
  for (const el of document.querySelectorAll<HTMLElement>('.pp-spinner')) {
    el.style.display = 'none';
  }
}
